module.exports = __webpack_public_path__ + "img/20221111_Steaker_incident.2dedb99b.png";